export default "__VITE_ASSET__BLAJ72MO__"